import _ from "lodash";
import { createSelector } from "reselect";
import { getInitials } from "sweet-global";
import { RootState } from "sweet-web/redux";

const s = (state: RootState) => state.user;

export const user = (state: RootState) => _.get(s(state), "entity");

export const isUpdatingUser = (state: RootState) => s(state).isUpdatingUser;

export const isCreatingUser = (state: RootState) => s(state).isCreatingUser;

export const userType = createSelector(user, userEntity =>
  userEntity ? userEntity.type : null
);

export const userVenues = createSelector(user, userEntity =>
  userEntity && userEntity.type === "VENUE" ? userEntity.venues : null
);

export const firstName = createSelector(user, userEntity =>
  userEntity ? userEntity.firstName : null
);

export const lastName = createSelector(user, userEntity =>
  userEntity ? userEntity.lastName : null
);

export const userEmail = createSelector(user, userEntity =>
  userEntity ? userEntity.emailAddress : null
);

export const userName = createSelector(user, userEntity =>
  userEntity ? `${userEntity.lastName} ${userEntity.lastName}` : null
);

export const userImage = createSelector(user, userEntity =>
  userEntity ? userEntity.image : null
);

export const userInitials = createSelector(
  firstName,
  lastName,
  (userFirstName, userLastName) =>
    userFirstName ? getInitials(`${userFirstName} ${userLastName}`) : null
);

export const userPhoneNumber = createSelector(
  user,
  userEntity => userEntity.phoneNumber
);
